export function getMoney(value){
  if(value) return `￥${(value/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  if(value == 0) return `￥${(value/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  return '';
}

export function getTime(value) {
  if(value) {
    var time = new Date(value);
    let Y = time.getFullYear() + '-';
    let M = (time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1) + '-';
    let D =( time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + '';
    
    return Y+M+D;
  } else {
    return '';
  }
}

export function phoneStr(value) {
  if(value && value.length == 11) return  value.substring(0,4) + '***' + value.substring(7,value.length);
  return "";
}

// 车牌颜色
export function getPlateColor(color){
  switch (color) {
    case 0: return "蓝色"
    case 1: return "黄牌"
    case 2: return "黑牌"
    case 5: return "大型新能源"
    case 4: return "新能源"
    default: return ""
  }
}

